import { Language } from "../languages/labels/language.labels";

export function accountingEntryTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'simple', display: lang.labels.writingSimple },
    { code: 'multiple-simplified', display: lang.labels.writingSimplifiedMultiple },
    { code: 'multiple', display: lang.labels.writingMultiple }
  ]
}

export function accountingEntryDebitTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'interest', display: lang.labels.customerInterest },
    { code: 'penalty', display: lang.labels.customerPenalty },
    { code: 'refund', display: lang.labels.customerRefund },
    { code: 'payment', display: lang.labels.providerPayment },
    { code: 'credit-note', display: lang.labels.providerCreditNote }
  ]
}

export function accountingEntryCreditTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'interest', display: lang.labels.providerInterest },
    { code: 'penalty', display: lang.labels.providerPenalty },
    { code: 'refund', display: lang.labels.providerRefund },
    { code: 'payment', display: lang.labels.customerPayment },
    { code: 'credit-note', display: lang.labels.customerCreditNote }
  ]
}

export function accountingEntryDebitCreditTypeList(lang: Language): {code: string, display: string}[] {
  let accountingEntryDebitCreditType = [
    { code: 'invoice', display: lang.labels.invoice },
    { code: 'provider-invoice', display: lang.labels.providerInvoice },
    { code: 'expense', display: lang.labels.expense },
    { code: 'treasury-account', display: lang.labels.treasuryAccount },
    { code: 'interest', display: lang.labels.interest },
    { code: 'penalty', display: lang.labels.penalty },
    { code: 'refund', display: lang.labels.refund },
    { code: 'payment', display: lang.labels.payment },
    { code: 'credit-note', display: lang.labels.creditNote },
    { code: 'none', display: lang.labels.none }
  ]

  return Array.from((new Map(accountingEntryDebitCreditType.map((item) => [item.code, item]))).values())
}

export function accountingEntryTypeValue(lang: Language, code: string): string {
  let accountType = accountingEntryTypeList(lang).find((item) => (item.code === code))
  return accountType ? accountType.display : lang.labels.undefined
}

export function accountingEntryDebitTypeValue(lang: Language, code: string): string {
  let accountType = accountingEntryDebitTypeList(lang).find((item) => (item.code === code))
  return accountType ? accountType.display : lang.labels.undefined
}

export function accountingEntryCreditTypeValue(lang: Language, code: string): string {
  let accountType = accountingEntryCreditTypeList(lang).find((item) => (item.code === code))
  return accountType ? accountType.display : lang.labels.undefined
}

export function accountingEntryDebitCreditTypeValue(lang: Language, code: string): string {
  let accountType = accountingEntryDebitCreditTypeList(lang).find((item) => (item.code === code))
  return accountType ? accountType.display : lang.labels.undefined
}
